<template>
	<div style="padding:30px">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<!-- <el-breadcrumb-item :to="{ path: '/admin/MyMeeting' }">会议管理</el-breadcrumb-item>
			<el-breadcrumb-item :to="{path:'/admin/MyMeeting'}">我的会议</el-breadcrumb-item>-->
			<el-breadcrumb-item>
				订单详情&nbsp;&nbsp;&nbsp;&nbsp;
				<el-button type="primary" @click="back1">返回列表</el-button>
			</el-breadcrumb-item>
		</el-breadcrumb>
		<div>
			<div>
				<h4>订单详情</h4>
				<p>订单编号：{{order_info.order_no}}</p>
				<p>下单时间：{{order_info.start_time | dateformat}}</p>
				<p>实际支付：{{order_info.dis_amount}}</p>
				<p v-show="order_info.pay_time!=null">订单支付时间：{{order_info.pay_time | dateformat}}</p>
				<p v-show="order_info.pay_type=='system'">
					支付方式：
					<span style="color:#E6A23C">系统</span>系统
				</p>
				<p v-show="order_info.pay_type==' admin'">
					支付方式：
					<span style="color:#E6A23C">管理员</span>
				</p>
				<p v-show="order_info.pay_type=='purse'">
					支付方式：
					<span style="color:#E6A23C">余额支付</span>
				</p>
				<p v-show="order_info.pay_type=='gold'">
					支付方式：
					<span style="color:#E6A23C">金币支付</span>
				</p>
				<p v-show="order_info.pay_type=='alipay'">
					支付方式：
					<span style="color:#409EFF">支付宝</span>
				</p>
				<p v-show="order_info.pay_type=='wxpay'">
					支付方式：
					<span style="color:#67C23A">微信支付</span>
				</p>
				<p v-show="order_info.pay_type==' unipay'">
					支付方式：
					<span style="color:#E6A23C">银联支付</span>
				</p>
				<p v-show="order_info.pay_type==' offline'">
					支付方式：
					<span style="color:#E6A23C">汇款</span>
				</p>
				<p v-show="order_info.pay_type==' paycard'">
					支付方式：
					<span style="color:#E6A23C">充值卡</span>
				</p>
				<p>
					可退款截止时间：
					<span style="margin-right:20px;color: red;">{{order_info.refund_endtime| dateformat}}</span>
					<button type="button" class="layui-btn  layui-btn-sm el-button--primary " @click="changeRefundtime">修改</button>
				</p>
				<p>
					订单状态： &nbsp;
					<el-tag v-if="order_info.order_status_str=='等待支付'">{{order_info.order_status_str}}</el-tag>
					<el-tag v-else-if="order_info.order_status_str=='已支付'" type="success">{{order_info.order_status_str}}</el-tag>
					<el-tag v-else-if="order_info.order_status_str=='订单删除'" type="danger">{{order_info.order_status_str}}</el-tag>
					<el-tag type="info" v-else>{{order_info.order_status_str}}</el-tag>
					<button v-show="order_info.pay_type=='offline' && order_info.order_status_str=='等待支付'" style="margin-left:10px" class="layui-btn   layui-btn-sm layui-btn-danger" @click="pay">确认是否已汇款?</button>
					<button v-show="order_info.order_status_str=='申请退款'" style="margin-left:10px" class="layui-btn  layui-btn-sm layui-btn-danger" @click="remove_payment">退款</button>
					<!-- <button v-show="order_info.order_status_str=='申请退款'" style="margin-left:10px" class="layui-btn   layui-btn-sm layui-btn-warm" @click="no_payment">拒绝退款</button> -->

					<button v-show="order_info.order_status_str=='拒绝退款' || order_info.order_status_str=='订单完成'" style="margin-left:10px" class="layui-btn  layui-btn-sm layui-btn-warm" @click="addRefundStatus = true;">申请退款</button>
				</p>
				<p v-show="order_info.order_status_str=='退款被驳回'">驳回原因：{{order_info.note}}</p>
			</div>
			<div v-if="invoice.length == undefined">
				<h4>发票信息</h4>
				<p>发票单号：{{invoice.invoice_no}}</p>
				<p>发票金额：{{invoice.amount}} 元</p>
				<p>申请时间：{{invoice.create_time | dateformat}}</p>
				<p>发票状态：
					<span style="color:#409EFF">
						<template v-if="invoice.status == 0">
							禁用
						</template>
						<template v-else-if="invoice.status == 1">
							待审核 &nbsp;&nbsp; <button class="layui-btn layui-btn-danger layui-btn-sm"  @click="delInvoice">取消申请</button>
						</template>
						<template v-else-if="invoice.status == 2">
							审核未通过
						</template>
						<template v-else-if="invoice.status == 3">
							审核通过
						</template>
						<template v-else-if="invoice.status == 4">
							取消申请    <button class="layui-btn el-button--primary layui-btn-sm" @click="goaddInvoice">申请发票</button>
						</template>
						<template v-else-if="invoice.status == -1">
							已删除
						</template>
					</span>
				</p>
				<p>发票抬头：{{invoice.invoice_info.title}}</p>
				<p>税号：{{invoice.invoice_info.tax_no}}</p>

				<button v-if="invoice.status != 3" class="layui-btn el-button--primary" @click="addInvoiceTo">重新推送发票</button>

			</div>
			<div v-else>
				<h4>发票信息</h4>
				<button class="layui-btn  layui-btn-sm el-button--primary" @click="goaddInvoice">申请发票</button>
			</div>
			<div>
				<h4>商品信息</h4>
				<p>主会议</p>
				<el-table :data="conference" stripe style="width: 100%" :header-cell-style="getRowClass">
					<el-table-column label="订单信息" width="470">
						<template slot-scope="scope">
							<el-row :gutter="20">
								<el-col :span="8" block>
									<div class="grid-content bg-purple">
										<el-image :src="scope.row.cover_url" style="height:80px;vertical-align: middle;"></el-image>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="grid-content bg-purple" style="font-size: 12px;">
										<div></div>
										<div>报名时间：{{scope.row.enroll_start_time | dateformat}} ~ {{scope.row.enroll_end_time | dateformat}}</div>
										<div>地点：{{scope.row.city_name}}</div>
									</div>
								</el-col>
							</el-row>
						</template>
					</el-table-column>
					<el-table-column prop="ticket_type" label="规格"></el-table-column>
					<el-table-column prop="price" label="单价"></el-table-column>
					<el-table-column prop="meet_peoples" label="报名信息"></el-table-column>
					<el-table-column prop="pishu_group" label="课题组"></el-table-column>
				    <el-table-column prop="user_mark" label="标记信息"></el-table-column>
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<div style="display: flex;flex-direction: column;justify-content: flex-start;">
								<el-button style="margin: 0; margin-top: 10px;" size="mini" type="primary" @click="biaoji(scope.row)">标记信息</el-button>
								<el-button style="margin: 0; margin-top: 10px;" size="mini" type="primary" @click="changeKetizu(scope.row)">修改课题组</el-button>
								<el-button style="margin: 0; margin-top: 10px;" size="mini" type="primary" @click="showEditorInfo(scope.row)">修改人员信息</el-button>
								<el-button style="margin: 0; margin-top: 10px;" size="mini" type="danger" @click="delectHy(scope.row)">删除</el-button>
							</div>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="address" label="实收款"></el-table-column> -->
				</el-table>

				<p style="margin-top:15px">平行会议</p>
				<el-table :data="parallel" stripe style="width: 100%" :header-cell-style="getRowClass" :show-header="showHeader=false">
					<el-table-column label="订单信息" width="470">
						<template slot-scope="scope">
							<el-row :gutter="20">
								<el-col :span="8" block>
									<div class="grid-content bg-purple">
										<el-image :src="scope.row.cover_url" style="height:80px;vertical-align: middle;"></el-image>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="grid-content bg-purple" style="font-size: 12px;">
										<div></div>
										<div>报名时间：{{scope.row.enroll_start_time | dateformat}} ~ {{scope.row.enroll_end_time | dateformat}}</div>
										<div>地点：{{scope.row.city_name}}</div>
									</div>
								</el-col>
							</el-row>
						</template>
					</el-table-column>
					<el-table-column prop="ticket_type" label="规格"></el-table-column>
					<el-table-column prop="price" label="单价"></el-table-column>
					<el-table-column prop="meet_peoples" label="报名信息"></el-table-column>
					<!-- <el-table-column prop="address" label="实收款"></el-table-column> -->
				</el-table>

				<p style="margin-top:15px;overflow: hidden;">住宿   <button  class="layui-btn el-button--primary layui-btn-sm" style="float:right;" @click="openHotelTan('')" >添加住宿信息</button></p>
				<el-table :data="hotel" stripe style="width: 100%" :header-cell-style="getRowClass">
					<el-table-column label="酒店名称" prop="h_name"></el-table-column>
					<el-table-column label="入住时间">
						<template slot-scope="scope">
							<span>{{scope.row.start_time | dateformat}}</span>至
							<p>{{scope.row.end_time | dateformat}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="hotel_type" label="房间类型"></el-table-column>
					<el-table-column prop="price" label="价位"></el-table-column>
					<el-table-column prop="peoples" label="住宿人"></el-table-column>
					<el-table-column label="操作" align="center" width="auto">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="openHotelTan(scope.row)">编辑</el-button>
							<el-button size="mini" type="danger" @click="delectHotel(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<p style="margin-top:15px">用餐</p>
				<el-table :data="repast" stripe style="width: 100%" :header-cell-style="getRowClass">
					<el-table-column prop="data.address" label="用餐地点"></el-table-column>
					<el-table-column label="就餐时间">
						<template slot-scope="scope">
							<span>{{scope.row.data.start_time | dateformat}}</span>至
							<p>{{scope.row.data.end_time | dateformat}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="number" label="用餐人数"></el-table-column>
				</el-table>
			</div>
		</div>

		<el-dialog :title="hotelTitle" :visible.sync="hotelDialog" :modal-append-to-body="true" center :show-close="false">
			<form action class="layui-form" id="changeHotel" lay-filter="changeHotel" style="width: 100%;">
				<div class="layui-form-item" style="margin-top: 20px; display: flex;" id="one_zd">
					<label class="layui-form-label" style="width: 150px;">
						房间类型
						<span style="color: red;font-size: 150%">*</span>:
					</label>
					<div class="layui-input-block" style="width: calc(100% - 150px); margin: 0;">
						<select name="hotel_type" lay-filter="fieldType" id="formtype">
							<template v-for="(items,index) in hotelDate">
								<option :value="items.id">{{items.name}}_{{items.hotel_type}}</option>
							</template>
						</select>
					</div>
				</div>
				<div class="layui-form-item date" style="display: flex;">
					<label class="layui-form-label" style="width: 150px;">
						入住时间
						<span style="color: red;font-size: 150%">*</span>:
					</label>
					<div class="layui-inline" style="width: calc(100% - 150px); margin: 0;">
						<div class="layui-input-inline">
							<input type="text" name="hotel_start_time" lay-verify="required" id="upTimeStart" placeholder="开始日期" autocomplete="off" readonly="readonly" class="layui-input" />
						</div>
						<div class="layui-form-mid">-</div>
						<div class="layui-input-inline">
							<input type="text" name="hotel_end_time" lay-verify="required" id="upTimeEnd" placeholder="结束日期" autocomplete="off" readonly="readonly" class="layui-input" />
						</div>
					</div>
				</div>
				<div class="layui-form-item" style="display: flex;" id="nine_zd">
					<label class="layui-form-label" style="width: 150px;">住宿人1<span style="color: red;font-size: 150%">*</span>:</label>
					<div class="layui-input-block" style="width: calc(100% - 150px); margin: 0;">
						<input name="name1" type="text" placeholder="请输入" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<div class="layui-form-item" style="display: flex;" id="nine_zd">
					<label class="layui-form-label" style="width: 150px;">住宿人2:</label>
					<div class="layui-input-block" style="width: calc(100% - 150px); margin: 0;">
						<input name="name2" type="text" placeholder="请输入" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<div class="layui-form-item" style="display: flex;" id="ask_member_name">
					<label class="layui-form-label" style="width: 150px;">要求修改人姓名<span style="color: red;font-size: 150%">*</span>:</label>
					<div class="layui-input-block" style="width: calc(100% - 150px); margin: 0;">
						<input name="ask_member_name" type="text" placeholder="请输入" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<div class="layui-form-item" style="display: flex;" id="ask_member_phone">
					<label class="layui-form-label" style="width: 150px;">要求修改人电话<span style="color: red;font-size: 150%">*</span>:</label>
					<div class="layui-input-block" style="width: calc(100% - 150px); margin: 0;">
						<input name="ask_member_phone" type="text" placeholder="请输入" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<div class="layui-form-item" style="display: flex;" id="ask_notes">
					<label class="layui-form-label" style="width: 150px;">备注:</label>
					<div class="layui-input-block" style="width: calc(100% - 150px); margin: 0;">
						<input name="ask_notes" type="text" placeholder="请输入" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<div class="layui-form-item" style="display: flex; text-align: center; padding-left: 150px;" id="ten_zd">
					<button type="button" class="layui-btn" lay-submit lay-filter="formDemo">确定</button>
					<button type="reset" class="layui-btn layui-btn-primary" @click="removea">取消</button>
				</div>
			</form>
		</el-dialog>


		<el-dialog :width="ism" title="填写发票信息"   v-if="invoiceDialog"  :visible.sync="invoiceDialog" :modal-append-to-body="true" center>
			<invoiceDialogdom @closeInvoiceTan="closeInvoiceTan" @openInvoiceNumDialog="openInvoiceNumDialog"></invoiceDialogdom>
		</el-dialog>
		<el-dialog :width="ism" title="设置发票数量" v-if="invoiceNumDialog" :visible.sync="invoiceNumDialog" :modal-append-to-body="true" center>
			<invoiceNumDom @closeInvoiceTan="closeInvoiceTan" @openInvoiceNumDialog="openInvoiceNumDialog"></invoiceNumDom>
		</el-dialog>

		<!-- 修改课题组-->
		<el-dialog :width="ism"  title="修改课题组"   :visible.sync="changeKtzStatus" :modal-append-to-body="false" center>
			<div class="pishuChangebox">
			<form class="layui-form" action="" id="pishuChange"  lay-filter="pishuChange" >
				<div class="layui-form-item">
				<input type="text" name="title" v-model="psSearchVal" autocomplete="off" placeholder="请输入您要搜索的皮书课题组" class="layui-input" @keyup="zdySearchKeyUp" @input="zdySearchKeyUp">
				</div>
				<div class="inputRadio" style="max-height:60vh;overflow-x:hidden;">
					<template v-for="(item,index) in searchPishu">
						<div v-if="item.name == psSearchVal" class="max50">
							<input type="radio" name="pishu" :value="item.name" :title="item.name" checked="checked" v-model="pschangeVal" :disabled="item.last_num > 0 ?false:true">
							<label for="pishu">{{item.name}}</label>
						</div>
						<div  v-else class="max50">
							<input type="radio" name="pishu" :value="item.name" :title="item.name" v-model="pschangeVal" :disabled="item.last_num > 0 ?false:true">
							<label for="pishu">{{item.name}}</label>
						</div>

					</template>
				</div>
				<div class="layui-form-item" style="text-align: center"  >
					<button type="button" class="layui-btn"  @click="addPishuChangebtn" >确定</button>
				</div>
			</form>
			</div>

		</el-dialog>

		<el-dialog :visible.sync="editor_info_visible" :title="form_editor_info.title" destroy-on-close>
			<el-form :model="form_editor_info" :rules="form_editor_rules" ref="form_editor">
				<el-form-item v-if="editor_info_type == 'edit'" label="报名人姓名" prop="name" label-width="125px">
					<el-input v-model="form_editor_info.name" size="small" />
				</el-form-item>
				<el-form-item v-if="editor_info_type == 'edit'" label="报名人电话" prop="tel" label-width="125px">
					<el-input v-model="form_editor_info.tel" size="small" />
				</el-form-item>
				<el-form-item label="要求修改人姓名" prop="required_name" style="" label-width="125px" >
					<el-input v-model="form_editor_info.required_name" size="small" />
				</el-form-item>
				<el-form-item label="要求修改人电话" prop="required_tel" style="" label-width="125px" >
					<el-input v-model="form_editor_info.required_tel" size="small" />
				</el-form-item>
				<el-form-item label="备注" prop="note" style="" label-width="125px">
					<el-input type="textarea" v-model="form_editor_info.note" size="small" />
				</el-form-item>
				<el-form-item label-width="125px">
					<div class="btn_box" style="margin-top: 20px;">
						<el-button @click="editor_info_visible = false;">取消</el-button>
						<el-button :type="editor_info_type == 'edit' ? 'primary' : 'warning'" @click="handleUpdateEditorInfo" >确定</el-button>
					</div>
				</el-form-item>
			</el-form>
		</el-dialog>

		<!--申请退款-->
		<el-dialog :width="ism"  title="申请退款"   :visible.sync="addRefundStatus" :modal-append-to-body="false" center>
			<div class="pishuChangebox">
				<form class="layui-form" action="" id="addRefundbox"  lay-filter="addRefundbox" >
					<div class="layui-form-item">
						<input type="text" name="title" v-model="addRefundText" autocomplete="off" placeholder="请输入您的退款理由" class="layui-input">
					</div>
					<div class="layui-form-item" style="text-align: center"  >
						<button type="button" class="layui-btn" :disabled="addRefundBtnStatus"  @click="addRefundBtn" >确定</button>
					</div>
				</form>
			</div>
		</el-dialog>

		<!--标记信息-->
		<el-dialog :width="ism"  title="标记信息"   :visible.sync="biaojiStatus" :modal-append-to-body="false" center :close-on-click-modal="false">
			<div class="pishuChangebox">
				<form class="layui-form" action="" id="addRefundbox"  lay-filter="addRefundbox" >
					<div class="layui-form-item">
						<input type="text" name="title" v-model="biaojiText" autocomplete="off" placeholder="请输入" class="layui-input">
					</div>
					<div class="layui-form-item" style="text-align: center"  >
						<button type="button" class="layui-btn" :disabled="biaojiBtnStatus"  @click="addBiaoji" >确定</button>
					</div>
				</form>
			</div>
		</el-dialog>


		<!-- 修改截止退款时间 -->
		<el-dialog :width="ism"  title="修改可退款截止时间"   :visible.sync="refundtimeStatus" :modal-append-to-body="false" center>
			<div>
				<input type="text" name="refundtimeInput" lay-verify="required" id="refundtimeInput" placeholder="选择时间" autocomplete="off" readonly="readonly" class="layui-input" style="margin-bottom: 40px;" />
				<div class="layui-form-item" style="text-align: center"  >
						<button type="button" class="layui-btn"  @click="postRefundtime" >确定</button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import invoiceDialogdom from '@/pages/OrderDetails/invoiceDialog'
import invoiceNumDom from '@/pages/OrderDetails/invoiceNum'

export default {
	name: "Orderdetails",
	components: {
		invoiceDialogdom,
		invoiceNumDom
	},
	data() {
		return {
			refundtimeStatus:false,//可截止退款时间弹框
			refundtimeInput:null,
			/* 订单信息 */
			order_info: {},
			/*会议id*/
			conferenceId: '',
			conferenceCode:'',//会议code
			/*主会议  */
			conference: [],
			//参会人
			memberBox:[],
			/*住宿  */
			hotel: [],
			/* 平行会议 */
			parallel: [],
			/* 就餐信息 */
			repast: [],
			/*发票信息*/
			invoice: [],
			order_pay: "",
			hotelTitle:'编辑住宿信息',
			hotelDialog: false,
			inHotelDate: {}, //修改住宿信息
			isAddhotel:false,//是否添加酒店
			hotelDate: [], //会议关联酒店
			invoiceDialog: false, //开发票
			invoiceNumDialog:false,//数量弹出

			ism: '600px', //弹框宽度
			changeKtzStatus:false,//修改课题组弹框
			pishuDepListbox:[],//皮书课题组
			searchPishu:[],//搜索出来的皮数组
			searchPishuStatus:true,
			pschangeVal:'',//选中的皮书组
			psSearchVal:'',//搜索皮书关键词
			pishuChecked:{
				dep_name:'',//皮书课题组
				order_no:'',//	订单号
				enroll_id:'',//	报名表id
			},//要修改的课题组
			addRefundStatus:false,//申请退款
			addRefundBtnStatus:false,
			addRefundText:'',//退款理由

			biaojiStatus:false,//标记信息
			biaojiBtnStatus:false,
			biaojiText:'',
			biaojibox:null,


			editor_info_visible: false,
			editor_info_type: 'edit',
			form_editor_info: {
				title: '修改人员信息',
				name: '',
				tel: '',
				required_name: '',
				required_tel: '',
				note: '',
			},
			form_editor_rules: {
				name: { required: true, message: '报名人姓名必填', trigger: 'blur' },
				tel: { required: true, message: '报名人电话必填', trigger: 'blur' },
				required_name: { required: true, message: '要求修改人姓名必填', trigger: 'blur' },
				required_tel: { required: true, message: '要求修改人电话必填', trigger: 'blur' },
			}
		};
	},
	created() {
		this.order_pay = this.$route.query.id;
		this.get_arr();

		var ua = document.body.offsetWidth;
		if (ua < 750) {
			this.ism = '100%';
		} else {
			this.ism = '600px';
		} 
	},
	methods: {
		//修改可退款时间
		changeRefundtime(){
			var _this = this;
			_this.refundtimeInput = _this.$options.filters['dateformat'](_this.order_info.refund_endtime);
			_this.refundtimeStatus = true;
		   setTimeout(() => {
			layui.use(
				[ 
					"laydate", 
				],
				function() {
					var layer = layui.layer; 
					var laydate = layui.laydate; 
					var upTimeStart = laydate.render({
						elem: "#refundtimeInput",
						type: "datetime",
						format: "yyyy-MM-dd HH:mm:ss",
						istime: true,
						istoday: true,
						isInitValue:true,
						value:_this.refundtimeInput,
						done: function(value, date) {
							if (value != "") {
								//date.month = date.month - 1;
								_this.refundtimeInput =  value;
							} 
						},
					});
				}
			);
		   }, 500);
		},
		postRefundtime(){
			var _this = this;
			let url = _this.APIurl.API.api.saverefundtime;
			_this.$get(url,{
				order_no:_this.order_pay,
				refund_endtime:new Date(_this.refundtimeInput).getTime()/1000
			}).then(res => {
				if (res.code == 1) {
					_this.$message({
						message: '修改成功',
						type: 'success',
						duration: 1000
					}); 
					_this.refundtimeStatus = false;
					_this.get_arr();
				} else { 
					_this.$message({
						message: res.msg,
						type: 'warning'
					});
				}
			})
		},
		//申请退款
		addRefundBtn(){
			var _this = this;
			_this.addRefundBtnStatus = true;
			if(_this.addRefundText == ''){
				_this.$message({
					type: "warning",
					message: "请填写退款理由！",
					duration: 1000,
				});
				_this.addRefundBtnStatus = false;
				return false;
			}
			let url = _this.APIurl.API.api.addRefund;
			_this.$get(url,{
				order_on:_this.order_pay,
				reason:_this.pishuChecked
			}).then(res => {
				if (res.code == 1) {
					_this.$message({
						message: '提交申请成功！',
						type: 'success',
						duration: 1000
					});
					setTimeout(function(){
						window.location.reload();
					},1000)
				} else {
					_this.addRefundBtnStatus = false;
					_this.$message({
						message: res.msg,
						type: 'warning'
					});
				}
			})
		},
		/* 时间去掉毫秒 */
		get_time(times) {
			var mill = times.getTime();
			return mill / 1000;
		},
		//自定义字段搜索下拉
		zdySearchKeyUp() {
			var _this = this;
			var inputText = _this.psSearchVal;
			var list = _this.pishuDepListbox;
			_this.searchPishu = [];
			var zhi = '';
			for (var i = 0; i < list.length; i++) {
				zhi = list[i];
				if (zhi.name.indexOf(inputText) != -1) { //因为indexof找不到的时候是一律为-1，所以直接判断是否为-1，不是就弹出这个值
					_this.searchPishu.push(list[i]); //将值放入第二个数组
				}
			}
			if(_this.searchPishu.length > 0){
				_this.searchPishuStatus = false;
			}else{
				_this.searchPishuStatus = true;
			}
		},
		getKeti(form){
			var _this = this;
			let url = _this.APIurl.API.api.pishuDepList;
			let params = {};
			_this.$get(url, params).then(res => {
				if (res.code == 1) {
					_this.pishuDepListbox = res.posts;
					_this.changeKtzStatus = true;
					_this.zdySearchKeyUp();
				} else {
					_this.$message({
						message: res.msg,
						type: 'warning'
					});
				}
			})
		},
		changeKetizu(item){
			var _this = this;
			_this.pishuChecked.enroll_id = item.id;
			_this.pishuChecked.order_no = _this.order_info.order_no;

			for(var i=0;i<item.fields.length;i++){
				if(item.fields[i].field_name == 'Research Group'){
					_this.psSearchVal = item.fields[i].value;
					_this.pschangeVal = item.fields[i].value;
				}
			}
			if(_this.pishuDepListbox.length < 1){
				_this.getKeti();
			}else{
				_this.changeKtzStatus = true;
				_this.zdySearchKeyUp();
			}

		},
		biaoji(item){
			this.biaojibox = item; 
			if(item.user_mark != ''){
				this.biaojiText = item.user_mark;
			}else{
				this.biaojiText = '';
			}
			this.biaojiStatus = true;
		},
		addBiaoji(){
			var _this = this;
			let url = _this.APIurl.API.api.membermark;
			let params = {
				id:_this.biaojibox.id,
				user_mark:_this.biaojiText
			};
			_this.$get(url, params).then(res => {
				if (res.code == 1) {
					_this.$message.success('标记成功');
					_this.biaojiStatus = false;
					 _this.get_arr();
				} else {
					_this.$message({
						message: res.msg,
						type: 'warning'
					});
				}
			})
		},
		showEditorInfo(item){
			const info = JSON.parse(JSON.stringify(item.member_info))
			this.editor_info_type = 'edit'
			this.form_editor_info = {
				title: '修改人员信息',
				...info
			}
			this.editor_info_visible = true
		},
		handleUpdateEditorInfo(){
			if(this.editor_info_type == 'edit'){
				this.$refs['form_editor'].validate((valid) => {
					if(valid){
						this.$post(this.APIurl.API.api.editenroll, {
							id: this.form_editor_info.id,
							name: this.form_editor_info.name,
							tel: this.form_editor_info.tel,
							ask_member_name: this.form_editor_info.required_name,
							ask_member_phone: this.form_editor_info.required_tel,
							ask_notes: this.form_editor_info.note,
						}).then(res => {
							if(res.code == 1){
								this.editor_info_visible = false
								this.$message.success('修改成功')
								this.get_arr()
							} else {
								this.$message.info(res.msg)
							}
						})
					}
				})
			} else if(this.editor_info_type == 'delete'){
				this.$refs['form_editor'].validate((valid) => {
					if(valid){
						let url = this.APIurl.API.api.deleteOrderItem;
						let params = {
							order_no: this.order_pay,
							ticket_id: this.form_editor_info.item.ticket_id,
							enroll_member_id: this.form_editor_info.item.id,
							ask_member_name: this.form_editor_info.required_name,
							ask_member_phone: this.form_editor_info.required_tel,
							ask_notes: this.form_editor_info.note,
						};
						this.$get(url, params).then(res => {
							if (res.code == 1) {
								this.$message({
									message: '删除成功',
									type: 'success',
									duration: 1000
								});
								window.location.reload();
							} else {
								this.$message({
									message: res.msg,
									type: 'warning'
								});
							}
						})
					}
				})
			} else if(this.editor_info_type == 'delete_hotel'){
				this.$refs['form_editor'].validate((valid) => {
					if(valid){
						let url = this.APIurl.API.api.deleteOrderHotel;
						let params = {
							order_no: this.order_pay,
							id: this.form_editor_info.item.m_id,
							ask_member_name: this.form_editor_info.required_name,
							ask_member_phone: this.form_editor_info.required_tel,
							ask_notes: this.form_editor_info.note,
						};
						this.$get(url, params).then(res => {
							if (res.code == 1) {
								this.$message({
									message: '删除成功',
									type: 'success',
									duration: 1000
								});
								window.location.reload();
							} else {
								this.$message({
									message: res.msg,
									type: 'warning'
								});
							}
						})
					}
				})
			}
		},
		addPishuChangebtn(){
			var _this = this;
			let url = _this.APIurl.API.api.editDep;
			_this.pishuChecked.dep_name = _this.pschangeVal;
			_this.$get(url, _this.pishuChecked).then(res => {
				if (res.code == 1) {
					_this.$message({
						message: '修改成功',
						type: 'success',
						duration: 1000
					});
					setTimeout(function(){
						window.location.reload();
					},1000)
				} else {
					_this.$message({
						message: res.msg,
						type: 'warning'
					});
				}
			})
		},
		back1() {
			var _this = this;
			_this.$router.back(-1);
		},
		/* 线下支付 */
		pay() {
			var _this = this;
			_this
				.$confirm("确认是否已汇款？", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
				.then(() => {
					let url = _this.APIurl.API.api.officepay;
					let params = {
						order_no: _this.order_info.order_no,
					};
					_this.$post(url, params).then((res) => {
						if (res.code == 1) {
							_this.$message({
								type: "success",
								message: "成功",
								duration: 1000,
							});
							_this.get_arr();
						} else {
							var a = res.msg;
							_this.$message({
								type: "warning",
								message: a,
								duration: 1000,
							});
						}
					});
				})
				.catch(() => {
					_this.$message({
						type: "info",
						message: "已取消",
						duration: 1000,
					});
				});
		},
		/* 退款 */
		remove_payment() {
			var _this = this;
			_this
				.$confirm("是否要退款？", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
				.then(() => {
					let url = _this.APIurl.API.api.removepay;
					let params = {
						order_no: _this.order_info.order_no,
						type: "0",
					};
					_this.$post(url, params).then((res) => {
						if (res.code == 1) {
							_this.$message({
								type: "success",
								message: "恭喜你,退款成功！",
								duration: 1000,
							});
							_this.get_arr();
						} else {
							var a = res.msg;
							_this.$message({
								type: "warning",
								message: a,
								duration: 1000,
							});
						}
					});
				})
				.catch(() => {
					_this.$message({
						type: "info",
						message: "已取消",
						duration: 1000,
					});
				});
		},
		/*拒绝退款*/
		no_payment() {
			var _this = this;
			_this
				.$prompt("请输入拒绝退款理由", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
				})
				.then(({
					value
				}) => {
					let url = _this.APIurl.API.api.removepay;;
					let params = {
						order_no: _this.order_info.order_no,
						type: "1",
						note: value,
					};
					_this.$post(url, params).then((res) => {
						if (res.code == 1) {
							_this.$message({
								type: "success",
								message: "成功 ",
								duration: 1000,
							});
							_this.get_arr();
						} else {
							_this.$message({
								type: "info",
								message: res.msg,
								duration: 1000,
							});
						}
					});
				})
				.catch(() => {
					_this.$message({
						type: "info",
						message: "已取消",
						duration: 1000,
					});
				});
		},
		/* 改变table表头背景色 */
		getRowClass({
			rowIndex
		}) {
			if (rowIndex == 0) {
				return "background:RGB(0,0,0)";
			} else {
				return "";
			}
		},
		/* 请求数据 */
		get_arr() {
			var _this = this;
			let url = _this.APIurl.API.api.dingdanlist;
			let params = {
				order_no: _this.order_pay,
			};
			_this.$get(url, params).then((res) => {
				var arr = res.posts;
				/*订单信息 */
				_this.conferenceId = arr.conference.conference.id;
				_this.conferenceCode = arr.conference.conference.code;
				_this.order_info = arr.order_info; /* 订单信息 */
				var order_list = arr.order_info;
				_this.getHotel();//获取酒店信息
				/* 主会议 ===============================================================*/
				var list_conferences = arr.conference.conference; /* 主会议信息 obj*/
				if (list_conferences === undefined) {
					list_conferences = [];
				}
				var data_list = arr.conference.data; /* 会议门票，人  arr*/
				_this.memberBox = data_list;
				if (data_list === undefined) {
					data_list = [];
				}

				_this.conference = []

				for (let m = 0; m < data_list.length; m++) {
					var list_conference_ticket = data_list[m].ticket; /* 主会议门票 obj*/
					var list_conference_member = data_list[m].member; /* 主会议用户 arr*/
					if (list_conference_member == "") {
						list_conference_member = [{
							name: "",
							tel: "",
						}, ];
					}
					let member_name = []; /* 会议用户姓名 */
					for (let l = 0; l < list_conference_member.length; l++) {
						// member_name.push(list_conference_member[l].name);
						// var m_name = member_name.toString();
						var list_conference_member_item = list_conference_member[l];
						var m_name = list_conference_member[l].name;
						var obj = {
							id: list_conference_member[l].id,
							fields:JSON.parse(list_conference_member[l].fields),
							ticket_id: list_conference_member[l].ticket_id,
							order_no: order_list.order_no /* 订单号 */ ,
							pay_type: order_list.pay_type,
							note: order_list.note,
							order_status: order_list.order_status_str /* 订单状态 */ ,
							ticket_type: list_conference_ticket.name /* 门票类型 */ ,
							price: list_conference_ticket.price /* 门票单价 */ ,
							name: list_conference_ticket.name /* 会议名称 */ ,
							city_name: list_conferences.city_name /* 城市 */ ,
							cover_url: list_conferences.cover_url /* 图片 */ ,
							meet_peoples: m_name /* 用户姓名 */ ,
							start_time: list_conferences.start_time /* 会议开始时间 */ ,
							end_time: list_conferences.end_time /* 会议结束时间 */ ,
							enroll_start_time: list_conferences.enroll_start_time /* 报名开始时间 */ ,
							enroll_end_time: list_conferences.enroll_end_time /* 报名结束时间 */ ,
							pishu_group: list_conference_member[l].pishu_group /* pishu_group */ ,
							member_info: list_conference_member_item,
							user_mark:list_conference_member[l].user_mark
						};
						_this.conference.push(obj);
					}
				}

				/* 酒店===================================================================== */
				var hotel = arr.hotel;
				for (let p = 0; p < hotel.length; p++) {
					var hotel_mation = hotel[p].hotel; /* 酒店信息 obj */
					var hotel_peoples = hotel[p].member; /* 酒店人 */
					for (let v = 0; v < hotel_peoples.length; v++) {
						var ar = []
						var strar = ""
						for (const item in hotel_peoples[v].name) {
							ar.push(hotel_peoples[v].name[item])
						}
						strar = ar.join(",")
						var obj_hotel = {
							id: hotel_mation.id,
							m_id: hotel_peoples[v].id,
							h_name: hotel_mation.h_name,
							start_time: hotel_peoples[v].start_time,
							end_time: hotel_peoples[v].end_time,
							hotel_type: hotel_mation.hotel_type,
							price: hotel_mation.price,
							peoples: strar,
							memberName: hotel[p].member[v].name
						};
						_this.hotel.push(obj_hotel);
					}
				}
				/* 平行会议============================================================== */
				var list_conferences = arr.parallel; /* 平行会议信息 obj*/
				if (list_conferences != []) {
					var list_parallel = list_conferences; /* 平行会议  arr*/
					for (let bc = 0; bc < list_parallel.length; bc++) {
						var list_parallel_conference = list_parallel[bc].conference; /*平行会议信息 obj*/

						var list_parallel_data = list_parallel[bc].data; /* 平行会议门票，用户信息 arr*/
						for (let m = 0; m < list_parallel_data.length; m++) {
							var list_conference_tickets =
								list_parallel_data[m].ticket; /* 平行会议门票 obj*/
							var list_conference_members =
								list_parallel_data[m].member; /* 平行会议用户 arr*/
							if (list_conference_members == "") {
								list_conference_members = [];
							}
							let member_names = []; /* 平行会议用户姓名 */
							for (let l = 0; l < list_conference_members.length; l++) {
								// member_names.push(list_conference_members[l].name);
								// var m_names = member_names.toString();
								var m_names = list_conference_members[l].name;
								var objs = {
									order_no: order_list.order_no /* 订单号 */ ,
									pay_type: order_list.pay_type,
									note: order_list.note,
									order_status: order_list.order_status_str /* 订单状态 */ ,
									ticket_type: list_conference_tickets.name /* 门票类型 */ ,
									price: list_conference_tickets.price /* 门票单价 */ ,
									name: list_conference_tickets.name /* 会议名称 */ ,
									city_name: list_parallel_conference.city_name /* 城市 */ ,
									cover_url: list_parallel_conference.cover_url /* 图片 */ ,
									meet_peoples: m_name /* 用户姓名 */ ,
									start_time: list_parallel_conference.start_time /* 会议开始时间 */ ,
									end_time: list_parallel_conference.end_time /* 会议结束时间 */ ,
									enroll_start_time: list_parallel_conference.enroll_start_time /* 报名开始时间 */ ,
									enroll_end_time: list_parallel_conference.enroll_end_time /* 报名结束时间 */ ,
								};
							}
							_this.parallel.push(objs);
						}
					}
				}

				/* 就餐=============================================== */
				_this.repast = arr.repast;

				/* 发票=============================================== */
				if (arr.invoice.length == undefined) {
					_this.invoice = arr.invoice;
					_this.invoice.invoice_info = arr.invoice.invoice_info;
				} 

			});
		},
		//删除门票
		delectHy(item) {
			var _this = this;
			this.editor_info_type = 'delete'
			this.form_editor_info = {
				title: '是否确认删除当前订单信息?',
				required_name: '',
				required_tel: '',
				note: '',
				item
			}
			this.editor_info_visible = true
			// _this.$confirm('是否确认删除当前订单信息?', '提示', {
			// 	confirmButtonText: '确定',
			// 	cancelButtonText: '取消',
			// 	type: 'warning'
			// }).then(() => {
			// 	let url = _this.APIurl.API.api.deleteOrderItem;
			// 	let params = {
			// 		order_no: _this.order_pay,
			// 		ticket_id: item.ticket_id,
			// 		enroll_member_id: item.id,
			// 	};
			// 	_this.$get(url, params).then(res => {
			// 		if (res.code == 1) {
			// 			_this.$message({
			// 				message: '删除成功',
			// 				type: 'success',
			// 				duration: 1000
			// 			});
			// 			window.location.reload();
			// 		} else {
			// 			_this.$message({
			// 				message: res.msg,
			// 				type: 'warning'
			// 			});
			// 		}
			// 	})
			// }).catch(() => {
			// 	this.$message({
			// 		type: 'info',
			// 		message: '已取消删除'
			// 	});
			// });
		},
		//删除酒店
		delectHotel(item) {
			var _this = this;
			this.editor_info_type = 'delete_hotel'
			this.form_editor_info = {
				title: '是否确认删除当前酒店信息?',
				required_name: '',
				required_tel: '',
				note: '',
				item
			}
			this.editor_info_visible = true
			// _this.$confirm('是否确认删除当前酒店信息?', '提示', {
			// 	confirmButtonText: '确定',
			// 	cancelButtonText: '取消',
			// 	type: 'warning'
			// }).then(() => {
			// 	let url = _this.APIurl.API.api.deleteOrderHotel;
			// 	let params = {
			// 		order_no: _this.order_pay,
			// 		id: item.m_id,
			// 	};
			// 	_this.$get(url, params).then(res => {
			// 		if (res.code == 1) {
			// 			_this.$message({
			// 				message: '删除成功',
			// 				type: 'success',
			// 				duration: 1000
			// 			});
			// 			window.location.reload();
			// 		} else {
			// 			_this.$message({
			// 				message: res.msg,
			// 				type: 'warning'
			// 			});
			// 		}
			// 	})
			// }).catch(() => {
			// 	this.$message({
			// 		type: 'info',
			// 		message: '已取消删除'
			// 	});
			// });
		},
		reashLaySelect() {
			var _this = this;
			layui.use(
				[
					"jquery",
					"element",
					"form",
					"laydate",
					"upload",
					"layedit",
					"layer",
					"table",
				],
				function() {
					var layer = layui.layer;
					var $ = layui.jquery;
					var element = layui.element;
					var form = layui.form;
					var laydate = layui.laydate;
					var layedit = layui.layedit;
					//会议信息(报名日期范围)
					var upTimeStart = laydate.render({
						elem: "#upTimeStart",
						type: "datetime",
						format: "yyyy-MM-dd HH:mm:ss",
						istime: true,
						istoday: true,
						done: function(value, date) {
							if (value != "") {
								date.month = date.month - 1;
								upTimeEnd.config.min = date;
							} else {
								upTimeEnd.config.min = upTimeStart.config.min;
							}
						},
					});

					var upTimeEnd = laydate.render({
						elem: "#upTimeEnd",
						type: "datetime",
						format: "yyyy-MM-dd HH:mm:ss",
						istime: true,
						istoday: true,
						done: function(value, date) {
							if (value != "") {
								date.month = date.month - 1;
								upTimeStart.config.max = date;
							} else {
								upTimeStart.config.max = upTimeEnd.config.max;
							}
						},
					});
					if(!_this.isAddhotel){
						var obj = {
							hotel_type: _this.inHotelDate.id,
							hotel_start_time: _this.$options.filters['dateformat'](_this.inHotelDate.start_time),
							hotel_end_time: _this.$options.filters['dateformat'](_this.inHotelDate.end_time),
							name1: _this.inHotelDate.memberName.name1,
							name2: _this.inHotelDate.memberName.name2,
						}
						form.val("changeHotel", JSON.parse(JSON.stringify(obj))); //赋值表单的
					}


					//监听提交
					form.on("submit(formDemo)", function(data) {
						if (data.field.name1 == '') {
							_this.$message({
								type: "error",
								message: '住宿人不能为空！',
								duration: 1000,
							});
							return false;
						}
						if (data.field.ask_member_name == '') {
							_this.$message({
								type: "error",
								message: '要求修改人姓名不能为空!',
								duration: 1000,
							});
							return false;
						}
						if (data.field.ask_member_phone == '') {
							_this.$message({
								type: "error",
								message: '要求修改人电话不能为空!',
								duration: 1000,
							});
							return false;
						}
						if( _this.isAddhotel){
							var params = {
								order_no:_this.order_pay,
								hotel_id: data.field.hotel_type,
								name1:data.field.name1,
								name2:data.field.name2,
								start_time: (new Date(data.field.hotel_start_time).getTime() / 1000),
								end_time: (new Date(data.field.hotel_end_time).getTime() / 1000),
								ask_member_name: data.field.ask_member_name,
								ask_member_phone: data.field.ask_member_phone,
								ask_notes: data.field.ask_notes,
							};
							let url = _this.APIurl.API.api.addOrderHotel;
							_this.$post(url, params).then((res) => {
								if (res.code == 1) {
									_this.$message({
										message: '添加成功',
										type: 'success',
										duration: 1000
									});
								window.location.reload();
								} else {
									_this.$message({
										type: "info",
										message: res.msg,
										duration: 1000,
									});
								}
							});
						}else{
							var params2 = {
								id: _this.inHotelDate.m_id,
								hotel_id: data.field.hotel_type,
								name: [data.field.name1, data.field.name2],
								start_time: (new Date(data.field.hotel_start_time).getTime() / 1000),
								end_time: (new Date(data.field.hotel_end_time).getTime() / 1000),
								ask_member_name: data.field.ask_member_name,
								ask_member_phone: data.field.ask_member_phone,
								ask_notes: data.field.ask_notes,
							};
							let url2 = _this.APIurl.API.api.editOrderHotel;
							_this.$get(url2, params2).then((res) => {
								if (res.code == 1) {
									_this.$message({
										message: '修改成功',
										type: 'success',
										duration: 1000
									});
									window.location.reload();
								} else {
									_this.$message({
										type: "info",
										message: res.msg,
										duration: 1000,
									});
								}
							});
						}

					});
				}
			);
		},
		//获取会议关联酒店
	 async getHotel() {
			var _this = this;
			let url = _this.APIurl.API.api.getHotel;
			let params = {
				id: _this.conferenceId,
			};
			await _this.$post(url, params).then((res) => {
				if (res.code == 1) {
					_this.hotelDate = res.posts; 
				} else {
					_this.$message({
						type: "info",
						message: res.msg,
						duration: 1000,
					});
				}
			});
		},

		//打开住宿弹框编辑页
		openHotelTan(item) {
			var _this = this;
			if(item == ''){
				_this.hotelTitle = '添加住宿信息';
				_this.isAddhotel = true;
				_this.inHotelDate = {
					order_no:_this.order_pay,
					hotel_id: '',
					name1:'',
					name2:'',
					start_time: (new Date().getTime() / 1000),
					end_time: (new Date().getTime() / 1000)
				}
			}else{
				_this.hotelTitle = '编辑住宿信息';
				_this.isAddhotel = false;
				_this.inHotelDate = item;
			}
			_this.hotelDialog = true; 
			setTimeout(() => {
				_this.reashLaySelect();
			}, 500);
		},
		//弹框取消
		removea() {
			this.hotelDialog = false;
			this.inHotelDate ={};
		},
		//申请发票
		goaddInvoice(){
			var _this = this; localStorage.setItem('invoiceMenu',JSON.stringify({order_no:_this.order_pay,allAmount:_this.order_info.dis_amount,code: _this.conferenceCode}));
			_this.invoiceDialog = true;
		},
		//重新推送发票
		addInvoiceTo(){
			var _this = this;
			let url = _this.APIurl.API.api.invoiceToPush;
			let params = {
				id:_this.invoice.id
			};
			_this.$post(url, params).then(res => {
				if (res.code == 1) {
					_this.$message({
						showClose: true,
						message:  '推送成功！',
						type: 'success'
					});
				} else {
					_this.$message({
						message: res.msg,
						type: 'warning'
					});
				}
			})
		},
		closeInvoiceTan(){
			var _this = this;
			_this.invoiceDialog = false;
			_this.invoiceNumDialog = false;
		},
		openInvoiceNumDialog(radio){
			var _this = this;
			if(radio == 1){
				_this.invoiceDialog = false;
				_this.invoiceNumDialog = true;
			}else{
				_this.invoiceDialog = true;
				_this.invoiceNumDialog = false;
			}

		},
		delInvoice(){
			var _this = this;
			_this.$confirm('是否确认取消当前发票申请?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let url = _this.APIurl.API.api.delInvoice;
				let params = {
					id:_this.invoice.id
				};
				_this.$get(url, params).then(res => {
					if (res.code == 1) {
						_this.$message({
							showClose: true,
							message:  '取消成功！',
							type: 'success'
						});
						setTimeout(function() {
							window.location.reload();
						}, 1000)

					} else {
						_this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			}).catch(() => {

			});
		}
	},
};
</script>
<style>
	#pishuChange .inputRadio{
		margin-bottom: 20px;
	}
	#pishuChange .max50{
		width: 47%;
		float: left;
	}
	#pishuChange .max50 input{
		float: left;
		height: 30px;
		margin: 0px 10px 0px 0;
	}
	#pishuChange .max50 >label{
		height: 30px;
		max-width: 85%;
		line-height: 30px;
		margin-bottom: 0px;
	}
	.inputRadio input[type=radio]{
		display: block!important;
	}
</style>
